export { default as ArrowRightPollIcon } from './ArrowRight'
